// extracted by mini-css-extract-plugin
export default {"token":"HeaderSubIssuesSummary-module__token--M4gHr","smallSummary":"HeaderSubIssuesSummary-module__smallSummary--n9ukK"};